import { getClient } from '~/lib/contensis/client'
import { Op, OrderBy, Query } from 'contensis-delivery-api'
import { isDevelopment } from '~/utils/misc'

const fields = [
  'entryTitle',
  'heading',
  'title',
  'description',
  'copy',
  'studyLevel',
  'studyMode',
  'courseVariants',
  'entryRequirements',
  'benefit',
  'type',
  'appStatus',
  'image',
  'date',
  'seoStandard',
  'building',
  'contract',
  'bathroom',
  'catering',
  'floorPlan',
  'accessible',
  'weeklyPrice',
  'totalPrice',
  'occupancyDates',
  'gallery',
  'fullName',
  'jobTitle',
  'profileImage',
  'briefBio',
  'email',
  'telephone',
  'backgroundColour',
  'featured',
  'heroStandard',
  'heroStandardAvantGarde',
  'status',
  'institute',
  'centre',
  'school',
  'theme',
  'duration',
  'location',
  'awardedBy',
  'categories',
  'virtual'
]

export const getFilters = async (type: string) => {
  const client = getClient()

  const query = new Query(
    Op.equalTo('sys.versionStatus', isDevelopment ? 'latest' : 'published'),
    Op.equalTo('sys.dataFormat', 'entry'),
    Op.equalTo('sys.contentTypeId', type)
  )
  query.pageSize = 100
  query.fields = ['entryTitle', 'id', 'label']
  query.orderBy = OrderBy.asc('label')
  try {
    const result = await client.entries.search(query)
    // console.log(result)
    return result
  } catch (err) {
    console.log(err)
  }
  return []
}

export const getResults = async (type: string) => {
  const client = getClient()

  // console.log('test', size, type)
  // const fields = ['entryTitle', 'sys', 'seoStandard']

  const query = new Query(
    Op.equalTo('sys.versionStatus', isDevelopment ? 'latest' : 'published'),
    Op.equalTo('sys.dataFormat', 'entry'),
    Op.equalTo('sys.contentTypeId', type)
  )

  query.pageSize = 2000
  query.fields = fields

  if (type === 'pageNewsArticle') {
    query.orderBy = OrderBy.desc('date')
  }

  if (type === 'pageEvent') {
    query.orderBy = OrderBy.asc('date.from')
  }

  // query.orderBy =
  //   type === 'pageNewsArticle'
  //     ? OrderBy.desc('date')
  //     : OrderBy.asc('sys.version.publihed')

  try {
    const result = await client.entries.search(query)
    // console.log(result, type)
    return result
  } catch (err) {
    console.log(err)
  }
}

// simple test
export const getEntryById = async (id: string) => {
  const client = getClient()
  try {
    const entry = await client.entries.get({
      id: id,
      fields: fields
    })
    // console.log(entry)
    return entry
  } catch (err) {
    console.log(err)
    return null
  }
}
